import React from 'react';
import { DeadlineClausesFlagCard } from './DeadlineClausesFlagCard';
import type { DeadlineFinding } from '../../services/api';

interface DeadlineClausesFlagsListProps {
  findings: DeadlineFinding[];
  selectedSectionKey: string | null;
}

export const DeadlineClausesFlagsList: React.FC<DeadlineClausesFlagsListProps> = ({
  findings,
  selectedSectionKey,
}) => {
  const filtered = selectedSectionKey
    ? findings.filter(
        (f) => `${f.articleNumber}-${f.sectionNumber}` === selectedSectionKey
      )
    : findings;

  if (filtered.length === 0) {
    return (
      <div className="text-center py-12 text-gray-400" data-testid="no-findings">
        {selectedSectionKey
          ? 'No deadline findings in this section.'
          : 'No deadline findings. Run the analysis to scan for time-bound obligations.'}
      </div>
    );
  }

  return (
    <div className="space-y-4" data-testid="deadline-flags-list">
      {filtered.map((finding) => (
        <DeadlineClausesFlagCard key={finding.id} finding={finding} />
      ))}
    </div>
  );
};
